/**
 * @file コンポーネント：RavnurPlayer スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledPlayerContainer = styled.div`
    width: 100%;
    height: 100%;

    &.hideControl .rmp-extensions,
    &.hidePlaceholder .rmp-ext-placeholder,
    &.hideVolume .rmp-ext-volume {
        display: none;
    }
`;

export const StyledRavnurPlayer = styled.div`
    width: 100%;
    height: 100%;

    .rmp-extensions {
        .rmp-ext-backward,
        .rmp-ext-forward {
            display: none;
        }
    }
`;
